import React, {useMemo} from 'react';
import {BarChart as StackedBarChart} from '../../components/Chart';
import {useProspectPoolTotalScoreRankHistoryChartDataQuery} from 'api';
import useSearchParams from '../useSearchParams';

export const ScoreHistoryChart: React.FC = () => {
  const {searchParams} = useSearchParams();

  const {data: {prospectPoolTotalScoreRankHistoryChartData} = {}} =
    useProspectPoolTotalScoreRankHistoryChartDataQuery({
      variables: {filter: searchParams},
    });

  const chartData = useMemo(() => {
    return prospectPoolTotalScoreRankHistoryChartData;
  }, [prospectPoolTotalScoreRankHistoryChartData]);

  if (!chartData) return null;

  return (
    <div className="bg-white">
      <StackedBarChart chart={chartData} style={{height: `513px`}} />
    </div>
  );
};